import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=b5e7fb46&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e7fb46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5e7fb46')) {
      api.createRecord('b5e7fb46', component.options)
    } else {
      api.reload('b5e7fb46', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=b5e7fb46&scoped=true&", function () {
      api.rerender('b5e7fb46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jcP8DZ4yl6zm/JS/comp/Voucher-Unit.vue"
export default component.exports